/** @jsx jsx */
import React, { useCallback, useEffect } from 'react';
import { jsx } from '@emotion/core';
import { InputProps as StandardInputProps } from '@material-ui/core/Input';
import MaskedInput from 'components/TextField/MaskedInput';
import { TextFieldProps, TextField } from '@material-ui/core';
import EditOutlined from '@material-ui/icons/EditOutlined';
import { decimalMoneyMask } from 'utils/masks';

import styles from './styles';
import useAnalyticVariables from 'hooks/useAnalyticVariables';
// import debounce from 'lodash.debounce';
import { useDebouncedCallback } from 'use-debounce';

type PropTypes = TextFieldProps;

const MiniIntendedPurchaseAmount: React.FC<PropTypes> = props => {
  const { setAnalyticsVariables } = useAnalyticVariables();

  const [setIPAAnalyticsDebounce] = useDebouncedCallback(
    (intendedPurchaseAmount: string) => {
      if (intendedPurchaseAmount) {
        setAnalyticsVariables({
          intendedPurchaseAmount: intendedPurchaseAmount.replace(
            /[^.|\d]/g,
            '',
          ),
        });
      }
    },
    200,
  );

  useEffect(() => {
    setIPAAnalyticsDebounce(props.value as string);
  }, [setIPAAnalyticsDebounce, props.value]);

  const maskedInputProps = {
    inputComponent: MaskedInput,
    inputProps: {
      ...{ mask: decimalMoneyMask },
      ...{ 'aria-label': 'Intended Purchase Amount' },
    },
  };
  const textFieldRef = React.createRef<HTMLInputElement>();
  const focus = useCallback(() => {
    if (textFieldRef.current) {
      textFieldRef.current.focus();
    }
  }, [textFieldRef]);

  const InputProps = {
    endAdornment: <EditOutlined css={styles.editIcon} onClick={focus} />,
    ...maskedInputProps,
    ...{
      disableUnderline: true,
    },
  } as Partial<StandardInputProps>;

  return (
    <div css={styles.editButton}>
      <TextField
        id="MiniIntendedPurchaseAmount"
        inputRef={textFieldRef}
        InputProps={InputProps}
        {...props}
      />
    </div>
  );
};

export default MiniIntendedPurchaseAmount;
